import React from 'react'
import GroupsDataTable from 'components/tables/GroupsDataTable'

const Groups = () => <GroupsDataTable />

export default Groups
